export default __webpack_public_path__ + "static/event_plakat_01-f4462e5d237a16f2f440c14fd52e26b6.png";